export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h4 className="font-heading text-lg font-bold mb-4">虫虫动漫</h4>
              <p className="text-sm text-foreground-300 leading-relaxed">
                虫虫动漫是专业的漫画全集免费在线阅读平台，提供下拉式一次性看完全卷完结漫画的便捷体验。
                我们致力于为漫画爱好者打造最舒适的全集漫画完整版阅读空间。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><a href="#index" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">漫画大全</a></li>
                <li><a href="#cards" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">精选推荐</a></li>
                <li><a href="#ranking" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">人气榜单</a></li>
                <li><a href="#updates" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">更新动态</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4">帮助中心</h4>
              <ul className="space-y-2.5">
                <li><a href="#faq" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">常见问题</a></li>
                <li><a href="#about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">关于我们</a></li>
                <li><a href="#contact" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">投稿合作</a></li>
                <li><a href="#features" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">平台特色</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                暂无合作伙伴信息
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-700/30">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400">
                &copy; {new Date().getFullYear()} 虫虫动漫 - 漫画全集免费在线阅读平台
              </p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-foreground-400">漫画全集 · 全集漫画 · 漫画完整版</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}